import React, { useEffect, useState } from 'react'

import { CircularProgress, MenuItem, Select } from '@mui/material'

import SingleFolderDownloadList from './SingleFolderDownloadList'
import Container from '../../common/primitives/Container'
import Message from '../../common/primitives/Message'

const MultipleFoldersDownloadList = ({ fileMap }) => {
  const [selectedKey, setSelectedKey] = useState('')

  const handleChange = (event) => {
    setSelectedKey(event.target.value)
  }

  useEffect(() => {
    setSelectedKey(Object.keys(fileMap)[0])
  }, [fileMap])

  if (
    !fileMap ||
    !Object.keys(fileMap) ||
    Object.keys(fileMap).length === 0 ||
    !selectedKey
  ) {
    return <CircularProgress />
  }

  return (
    <>
      <Message>
        Select your model:{' '}
        <Select
          variant="standard"
          size="small"
          value={selectedKey}
          label="Model Reference"
          onChange={handleChange}
        >
          {Object.keys(fileMap).map((key) => (
            <MenuItem key={key} value={key}>
              {key}
            </MenuItem>
          ))}
        </Select>
      </Message>
      <Container>
        <SingleFolderDownloadList files={fileMap[selectedKey]} />
      </Container>
    </>
  )
}

export default MultipleFoldersDownloadList
